import { render } from "./BibliographyEditor.vue?vue&type=template&id=850de562&scoped=true"
import script from "./BibliographyEditor.vue?vue&type=script&lang=js"
export * from "./BibliographyEditor.vue?vue&type=script&lang=js"

import "./BibliographyEditor.vue?vue&type=style&index=0&id=850de562&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850de562"]])

export default __exports__